import { fetcher } from "utils";
import { IJSendSuccessResponse } from "typings";

export function get__api__v1__userables__stores__only_ids(): Promise<IJSendSuccessResponse<{ payload: number[] }>> {
  return fetcher.get("/api/v1/userables/stores/only_ids");
}
